const state = {
	isLogin:false,
	info:{}
}
if(!state.info.id){
	const ui = localStorage.getItem("user-info")
	if(ui){
		state.info = JSON.parse(ui)
	}
}
const mutations = {
	userLogin(state,user){
		state.isLogin=true,
		state.info = user;
		localStorage.setItem("user-info",JSON.stringify(user));
	},
	userLogout(state){
		state.isLogin=false,
		state.info = {};
		localStorage.removeItem("user-info");
	}
}

export default{
	state,mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js